import Vue from 'vue'
import NuxtLoading from './components/nuxt-loading.vue'

import '../node_modules/bootstrap/dist/css/bootstrap.css'

import '../node_modules/bootstrap-vue/dist/bootstrap-vue.css'

import '../node_modules/@fortawesome/fontawesome-svg-core/styles.css'

import '../assets/css/dashboard.css'

import '../assets/scss/global.scss'

const _3c57bb4d = () => import('../layouts/landing-enterprise.vue'  /* webpackChunkName: "layouts/landing-enterprise" */).then(m => m.default || m)
const _c20c3794 = () => import('../layouts/landing-job-post-bubbles.vue'  /* webpackChunkName: "layouts/landing-job-post-bubbles" */).then(m => m.default || m)
const _157900c8 = () => import('../layouts/landing-job-post.vue'  /* webpackChunkName: "layouts/landing-job-post" */).then(m => m.default || m)
const _d0aa2108 = () => import('../layouts/landing-mfa.vue'  /* webpackChunkName: "layouts/landing-mfa" */).then(m => m.default || m)
const _c1af60d2 = () => import('../layouts/landing-partners.vue'  /* webpackChunkName: "layouts/landing-partners" */).then(m => m.default || m)
const _43f556fa = () => import('../layouts/landing-resource.vue'  /* webpackChunkName: "layouts/landing-resource" */).then(m => m.default || m)
const _3672582c = () => import('../layouts/landing-upskilling-cohort.vue'  /* webpackChunkName: "layouts/landing-upskilling-cohort" */).then(m => m.default || m)
const _103c6d61 = () => import('../layouts/landing.vue'  /* webpackChunkName: "layouts/landing" */).then(m => m.default || m)
const _f7662442 = () => import('../layouts/public.vue'  /* webpackChunkName: "layouts/public" */).then(m => m.default || m)
const _6f6c098b = () => import('./layouts/default.vue'  /* webpackChunkName: "layouts/default" */).then(m => m.default || m)

const layouts = { "_landing-enterprise": _3c57bb4d,"_landing-job-post-bubbles": _c20c3794,"_landing-job-post": _157900c8,"_landing-mfa": _d0aa2108,"_landing-partners": _c1af60d2,"_landing-resource": _43f556fa,"_landing-upskilling-cohort": _3672582c,"_landing": _103c6d61,"_public": _f7662442,"_default": _6f6c098b }

let resolvedLayouts = {}

export default {
  head: {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=3"},{"hid":"description","name":"description","content":"Workera helps you identify your skills and recommends the right AI roles for you by providing you with feedback, resources and a Credential that showcases your skillset in a particular role"},{"hid":"og:image","name":"og:image","property":"og:image","content":"https:\u002F\u002Fworkera.ai\u002Fshared-img2.png"},{"hid":"twitter:title","name":"twitter:title","content":"Workera (a deeplearning.ai company)"},{"hid":"twitter:description","name":"twitter:description","content":"Workera helps you identify your skills and recommends the right AI roles for you by providing you with feedback, resources and a Credential that showcases your skillset in a particular role"},{"hid":"twitter:card","name":"twitter:card","content":"summary_large_image"},{"hid":"twitter:site","name":"twitter:site","content":"@workera_"},{"hid":"twitter:image","property":"twitter:image","name":"twitter:image","content":"https:\u002F\u002Fworkera.ai\u002Fshared-img2.png"},{"hid":"twitter:creator","name":"twitter:creator","content":"@workera_"},{"hid":"twitter:domain","name":"twitter:domain","content":"workera.ai"},{"name":"ahrefs-site-verification","content":"2c7cfc27fef1ba8a67eeb7a1fd3a2c01070b6436a6e63db261d680e8b9b0eb7c"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"script":[{"src":"\u002FaccessiBe.js","body":true},{"src":"\u002Fmaze.js","body":true}],"style":[]},

  render(h, props) {
    const loadingEl = h('NuxtLoading', { ref: 'loading' })
    const layoutEl = h(this.layout || 'nuxt')
    const templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [ layoutEl ])

    const transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      },
      on: {
        beforeEnter(el) {
          // Ensure to trigger scroll event after calling scrollBehavior
          window.$nuxt.$nextTick(() => {
            window.$nuxt.$emit('triggerScroll')
          })
        }
      }
    }, [ templateEl ])

    return h('div', {
      domProps: {
        id: '__nuxt'
      }
    }, [
      loadingEl,
      transitionEl
    ])
  },
  data: () => ({
    isOnline: true,
    layout: null,
    layoutName: ''
  }),
  beforeCreate() {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt)
  },
  created() {
    // Add this.$nuxt in child instances
    Vue.prototype.$nuxt = this
    // add to window so we can listen when ready
    if (process.client) {
      window.$nuxt = this
      this.refreshOnlineStatus()
      // Setup the listeners
      window.addEventListener('online', this.refreshOnlineStatus)
      window.addEventListener('offline', this.refreshOnlineStatus)
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error
  },

  mounted() {
    this.$loading = this.$refs.loading
  },
  watch: {
    'nuxt.err': 'errorChanged'
  },

  computed: {
    isOffline() {
      return !this.isOnline
    }
  },
  methods: {
    refreshOnlineStatus() {
      if (process.client) {
        if (typeof window.navigator.onLine === 'undefined') {
          // If the browser doesn't support connection status reports
          // assume that we are online because most apps' only react
          // when they now that the connection has been interrupted
          this.isOnline = true
        } else {
          this.isOnline = window.navigator.onLine
        }
      }
    },

    errorChanged() {
      if (this.nuxt.err && this.$loading) {
        if (this.$loading.fail) this.$loading.fail()
        if (this.$loading.finish) this.$loading.finish()
      }
    },

    setLayout(layout) {
      if (!layout || !resolvedLayouts['_' + layout]) layout = 'default'
      this.layoutName = layout
      let _layout = '_' + layout
      this.layout = resolvedLayouts[_layout]
      return this.layout
    },
    loadLayout(layout) {
      const undef = !layout
      const nonexistent = !(layouts['_' + layout] || resolvedLayouts['_' + layout])
      let _layout = '_' + ((undef || nonexistent) ? 'default' : layout)
      if (resolvedLayouts[_layout]) {
        return Promise.resolve(resolvedLayouts[_layout])
      }
      return layouts[_layout]()
        .then((Component) => {
          resolvedLayouts[_layout] = Component
          delete layouts[_layout]
          return resolvedLayouts[_layout]
        })
        .catch((e) => {
          if (this.$nuxt) {
            return this.$nuxt.error({ statusCode: 500, message: e.message })
          }
        })
    }
  },
  components: {
    NuxtLoading
  }
}
